import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ChevronNavEditing from './chevronnavediting';

export default class ChevronNav extends Plugin {
  static get pluginName() {
    return 'ChevronNav';
  }

  static get requires() {
    return [ ChevronNavEditing ];
  }
}
